import cloneDeep from 'lodash/fp/cloneDeep'
import { events } from './adviserProfileContactDetailsEditorActions'
import { events as containerEvents } from '../AdviserProfileEditorContainer/adviserProfileEditorContainerActions'

const initialState = {
  deleteContactNumberModal: false,
  loadingContactNumbers: false,
  editingContactNumbers: false,
  editingIndex: -1,
  deletingContactNumberIndex: -1,
  editingPublicContactEmailAddress: false,
  loadingPublicContactEmailAddress: false,
  contactNumbersBeforeEditing: [],
  publicContactEmailAddressBeforeEditing: null,
  contactNumbers: [],
  publicContactEmailAddress: '',
  isInvalid: {
    formIsValid: false,
    contactNumbers: {
      isInvalid: true,
      message: 'Please enter your contact number',
      valid: false
    },
    publicContactEmailAddress: {
      isInvalid: true,
      message: 'Please enter your email address',
      valid: false
    }
  }
}

const isFormValidPublicContactEmail = (state) => {
  return state.contactDetails.isInvalid.publicContactEmailAddress.valid
}

const isFormValidContactNumbers = (state) => {
  return state.contactDetails.isInvalid.contactNumbers.valid
}

function isNumeric (n) {
  return !isNaN(parseFloat(n)) && isFinite(n)
}

export function validateEmail (value) {
  if (!value) {
    return {
      isInvalid: true,
      message: 'Please enter your email address',
      valid: false,
      pristine: true
    }
  }

  if (value.length < 3 || value.indexOf('@') < 0) {
    return {
      isInvalid: true,
      message: 'Email address is invalid',
      valid: false,
      pristine: false
    }
  }

  if (value.length > 320) {
    return {
      isInvalid: true,
      message: 'Email address exceeds max length (320)',
      valid: false,
      pristine: false
    }
  }

  let endingCharacter = value.slice(-1)
  if (endingCharacter === '.' || endingCharacter === '@') {
    return {
      isInvalid: true,
      message: 'Email address contains invalid characters',
      valid: false,
      pristine: false
    }
  }

  return {
    isInvalid: false,
    message: null,
    valid: true,
    pristine: false
  }
}

export function validatePhoneNumber (value) {
  if (!value) {
    return {
      isInvalid: true,
      message: 'Please enter your contact number',
      valid: false
    }
  }

  if (!isNumeric(value)) {
    return {
      isInvalid: true,
      message: 'Contact number must contain only digits',
      valid: false
    }
  }

  if (value.length < 10) {
    return {
      isInvalid: true,
      message: 'Contact number is not long enough',
      valid: false
    }
  }

  if (value.length > 15) {
    return {
      isInvalid: true,
      message: 'Contact number length is too long (15)',
      valid: false
    }
  }

  return {
    isInvalid: false,
    message: null,
    valid: true
  }
}

export default (state = initialState, action) => {
  var newState = copyContactNumbersState(state)
  const { add, edit, set, deletes } = events
  switch (action.type) {
    case containerEvents.edit.cancel:
      newState.contactDetails = cloneDeep(initialState)
      return newState
    case add.contactNumber:
      newState.contactDetails.contactNumbersBeforeEditing = cloneDeep(newState.profile.contactDetails.contactNumbers)
      newState.profile.contactDetails.contactNumbers.push(action.contactNumber)
      newState.contactDetails.editingContactNumbers = true
      newState.contactDetails.editingIndex = newState.profile.contactDetails.contactNumbers.length - 1
      newState.contactDetails.isInvalid.contactNumbers = cloneDeep(initialState.isInvalid.contactNumbers)
      newState.contactDetails.isInvalid.formIsValid = contactDetailsFormIsValid(newState)
      return newState
    case edit.contactNumber.start:
      newState.contactDetails.editingContactNumbers = true
      newState.contactDetails.editingIndex = action.index
      newState.contactDetails.contactNumbersBeforeEditing = cloneDeep(newState.profile.contactDetails.contactNumbers)
      if (!newState.profile.contactDetails.contactNumbers || (newState.profile.contactDetails.contactNumbers.length === 0)) {
        newState.contactDetails.isInvalid.contactNumbers.valid = false
      } else {
        newState.contactDetails.isInvalid.contactNumbers = validatePhoneNumber(newState.profile.contactDetails.contactNumbers[0].contactNumber)
      }
      newState.contactDetails.isInvalid.publicContactEmailAddress = validateEmail(newState.profile.contactDetails.publicContactEmailAddress)
      newState.contactDetails.isInvalid.formIsValid = contactDetailsFormIsValid(newState)
      return newState
    case edit.contactNumber.stop:
      newState.contactDetails.editingIndex = initialState.editingIndex
      newState.contactDetails.editingContactNumbers = initialState.editingContactNumbers
      newState.contactDetails.contactNumbersBeforeEditing = initialState.contactNumbersBeforeEditing
      newState.edited = true
      return newState
    case edit.contactNumber.cancel:
      newState.contactDetails.editingIndex = initialState.editingIndex
      newState.contactDetails.editingContactNumbers = initialState.editingContactNumbers
      newState.profile.contactDetails.contactNumbers = cloneDeep(newState.contactDetails.contactNumbersBeforeEditing)
      newState.contactDetails.contactNumbersBeforeEditing = initialState.contactNumbersBeforeEditing
      newState.profile.contactDetails.publicContactEmailAddress = cloneDeep(newState.contactDetails.publicContactEmailAddressBeforeEditing)
      newState.contactDetails.publicContactEmailAddressBeforeEditing = initialState.publicContactEmailAddressBeforeEditing
      if (!newState.profile.contactDetails.contactNumbers || (newState.profile.contactDetails.contactNumbers.length === 0)) {
        newState.contactDetails.isInvalid.contactNumbers.valid = false
      } else {
        newState.contactDetails.isInvalid.contactNumbers = validatePhoneNumber(newState.profile.contactDetails.contactNumbers[0].contactNumber)
      }
      newState.contactDetails.isInvalid.publicContactEmailAddress = validateEmail(newState.profile.contactDetails.publicContactEmailAddress)
      newState.contactDetails.isInvalid.formIsValid = contactDetailsFormIsValid(newState)
      return newState
    case set.contactNumber:
      newState.profile.contactDetails.contactNumbers[0] = { ...action.contactNumber }
      newState.contactDetails.isInvalid.contactNumbers = cloneDeep(action.validationResult)
      newState.contactDetails.isInvalid.formIsValid = contactDetailsFormIsValid(newState)
      newState.edited = true
      return newState
    case deletes.contactNumbers.modal:
      newState.contactDetails.deleteContactNumberModal = true
      newState.contactDetails.deletingContactNumberIndex = action.index
      return newState
    case deletes.contactNumbers.contactNumber:
      newState.profile.contactDetails.contactNumbers = newState.profile.contactDetails.contactNumbers.filter((contactNumber, index) => index !== newState.contactDetails.deletingContactNumberIndex)
      newState.contactDetails.deletingContactNumberIndex = initialState.deletingContactNumberIndex
      newState.contactDetails.deleteContactNumberModal = initialState.deleteContactNumberModal
      newState.edited = true
      return newState
    case deletes.contactNumbers.cancel:
      newState.contactDetails.deletingContactNumberIndex = initialState.deletingContactNumberIndex
      newState.contactDetails.deleteContactNumberModal = initialState.deleteContactNumberModal
      return newState
    case set.publicEmail:
      newState.profile.contactDetails.publicContactEmailAddress = cloneDeep(action.publicContactEmailAddress)
      newState.contactDetails.isInvalid.publicContactEmailAddress = cloneDeep(action.validationResult)
      newState.contactDetails.isInvalid.formIsValid = contactDetailsFormIsValid(newState)
      newState.edited = true
      return newState
  }

  return state
}

export function contactDetailsFormIsValid (newState) {
  return isFormValidContactNumbers(newState) && isFormValidPublicContactEmail(newState)
}

const copyContactNumbersState = (state) => {
  var newState = cloneDeep(state)
  newState.profile = cloneDeep(state.profile)
  if (state.profile) {
    newState.profile.contactDetails = cloneDeep(state.profile.contactDetails)
    if (state.profile.contactDetails) {
      newState.profile.contactDetails.contactNumbers = cloneDeep(state.profile.contactDetails.contactNumbers)
    }
  }

  return newState
}
